import script from "./UserDetailModal.vue?vue&type=script&setup=true&lang=js"
export * from "./UserDetailModal.vue?vue&type=script&setup=true&lang=js"

import "./UserDetailModal.vue?vue&type=style&index=0&id=3d5662da&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d5662da"]])

export default __exports__